import React from 'react';

// The real Wallmates mark, for when there's no deck (and so no company logo) to show. Never a typed wordmark.
const FALLBACK_MARK = '/logo192.png';

// #region DeckMessage
/** A calm full-page message: the deck expired, the link is wrong, or the server couldn't be reached. */
export const DeckMessage: React.FunctionComponent<{ title: string; body: React.ReactNode; logoUrl?: string | null }> = ({ title, body, logoUrl }): React.ReactElement => (
    <div className="flex min-h-screen items-center justify-center bg-[#f4f5f2] px-4 py-12 text-[#16201c]">
        <main className="w-full max-w-md rounded-2xl border border-[#e3e8e5] bg-white px-7 py-10 text-center shadow-sm">
            <img src={logoUrl || FALLBACK_MARK} alt="" className={logoUrl ? 'mx-auto mb-7 h-9 w-auto max-w-[200px] object-contain' : 'mx-auto mb-7 h-11 w-11'} />
            <h1 className="font-display text-2xl font-semibold tracking-tight">{title}</h1>
            <p className="mx-auto mt-3 max-w-sm text-[15px] leading-6 text-[#4b5853]">{body}</p>
        </main>
    </div>
);
